// PSA specific labels, translations, behavior per country

export default ['$filter', 'InsuranceSuiteMetadata', ($filter, InsuranceSuiteMetadata) => {

    const translator = $filter('translate');
    const orgTypelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('AccountOrgType');

    return {
        companyRegNumberLabelFor: (country) => {
            switch (country) {
                case 'DE':
                    return translator('psa.gateway.views.account-detail.Handelsregisternummer');
                case 'FR':
                case 'BE':
                case 'LU':
                    return translator('psa.gateway.views.account-detail.N° TVA');
                case 'IT':
                    return translator('psa.gateway.views.account-detail.CCIAA');
                case 'NL':
                    return translator('psa.gateway.views.account-detail.KvK');
                case 'ES':
                    return translator('psa.gateway.views.account-detail.CIF/NIF');
                case 'AT':
                    return translator('psa.gateway.views.account-detail.N° DUNS');
                case null:
                default:
                    return translator('psa.gateway.puw.views.new-quote.Company Registration Number');
            }
        },

        orgTypesFor: (country) => {
            // NOTE
            // NOTE: it takes generic unfiltered 'AccountOrgType' typelist. For not it is completely enough.
            // NOTE
            switch (country) {
                case 'DE':
                    return orgTypelist.getFilter("AccOrgDE_PSA").codes;
                case 'FR':
                    return orgTypelist.getFilter("AccOrgFR_PSA").codes;
                case 'BE':
                    return orgTypelist.getFilter("AccOrgBE_PSA").codes;
                case 'LU':
                    // TODO
                    // return orgTypelist.aspects.availableValues[0].typelist.getFilter("AccOrgLU_PSA").codes;
                    return orgTypelist.codes;
                case 'IT':
                    return orgTypelist.getFilter("AccOrgIT_PSA").codes;
                case 'NL':
                    return orgTypelist.getFilter("AccOrgNL_PSA").codes;
                case 'ES':
                    return orgTypelist.getFilter("AccOrgES_PSA").codes;
                case 'AT':
                    // TODO
                    // return orgTypelist.aspects.availableValues[0].typelist.getFilter("AccOrgAT_PSA").codes;
                    return orgTypelist.codes;
                case null:
                default:
                    return orgTypelist.codes;
            }
        },
        //   UCWPRODENG-772
       fiscalCodeLabelFor: (country) => {
            switch (country) {
                case 'ES':
                    return translator('psa.gateway.views.account-detail.Fiscal Code-ES');
                case null:
                default:
                    return translator('psa.gateway.puw.views.new-quote.Fiscal Code');
            }
        }
    };
}];
